import { IonContent, isPlatform } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInput } from '@/components/FormInput';
import { InfoProtection } from '@/components/InfoProtection';
import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import { checkIsValidateEmail } from '@/pages/Onboarding/utils/checkIsValidEmail';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { PageStyles } from './EmailScreen.styles';

export const EmailScreen: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Email',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();

  const inputRef = React.useRef<HTMLIonInputElement>(null);

  const formEmail = form.watch('email');
  const isValidEmail = checkIsValidateEmail(formEmail);

  React.useEffect(() => {
    if (isPlatform('android') || isPlatform('desktop')) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      });
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        }
      }, 1000);
    }
  }, []);

  const handleNextStep = (): void => {
    if (!formEmail || !isValidEmail) return;
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <PageStyles background="dark-solid">
      <OnboardingNavigation />

      <IonContent>
        <UiTypography variant="title-medium" className="email-title">
          She's almost finished with your
          <br />
          pool and ready for you
        </UiTypography>

        <UiTypography
          variant="body-large"
          className="email-subtitle"
          color="neutral-white"
        >
          Enter your email to continue <br />
          conversation
        </UiTypography>

        <div className="email-input-container">
          <FormInput
            form={form}
            hidden={false}
            onSubmit={handleNextStep}
            disableButton={!isValidEmail}
            ref={inputRef}
            name="email"
            type="email"
            placeholder="Type your email"
          />
        </div>

        <div className="email-protection">
          <InfoProtection />
        </div>
      </IonContent>
    </PageStyles>
  );
};
